import { PureComponent } from "react";
import ParagraphWithLogosComponent from "/components/core/paragraph-with-logos/paragraph-with-logos-component";
import { StyledIntegrationsComponent } from "./integrations-component.scss";

const INTEGRATIONS_ASSETS = [
  [
    {
      url: "/static/img/integrations/dropbox.png",
      alt: "Dropbox",
      href:
        "https://support.monday.com/hc/en-us/articles/115005339505-How-do-I-upload-files-and-attachments-in-monday-com-"
    },
    {
      url: "/static/img/integrations/excel.png",
      alt: "Excel",
      href: "https://support.monday.com/hc/en-us/articles/360000219209-How-to-import-and-export-to-Excel-"
    },
    {
      url: "/static/img/integrations/google_calendar.png",
      alt: "Google Calendar",
      href: "https://support.monday.com/hc/en-us/articles/360001362725-How-can-I-integrate-my-board-with-my-calendar-"
    },
    {
      url: "/static/img/integrations/google_drive.png",
      alt: "Google Drive",
      href:
        "https://support.monday.com/hc/en-us/articles/115005339505-How-do-I-upload-files-and-attachments-in-monday-com-"
    },
    {
      url: "/static/img/integrations/integromat.png",
      alt: "Integromat",
      href:
        "https://support.monday.com/hc/en-us/articles/360001265649-How-to-sync-timelines-between-2-boards-with-Integromat"
    },
    {
      url: "/static/img/integrations/slack.png",
      alt: "Slack",
      href: "https://support.monday.com/hc/en-us/articles/360001183089-How-to-use-the-Slack-internal-integration-"
    },
    {
      url: "/static/img/integrations/trello.png",
      alt: "Trello",
      href: "https://support.monday.com/hc/en-us/articles/360000274165-How-can-I-import-my-boards-from-Trello"
    },
    {
      url: "/static/img/integrations/zapier.png",
      alt: "Zapier",
      href: "https://support.monday.com/hc/en-us/articles/115005934989-How-to-create-an-integration-using-Zapier"
    }
  ]
];

export default class IntegrationsComponent extends PureComponent {
  render() {
    return (
      <StyledIntegrationsComponent className="integrations-component">
        <div className="paragraph-with-logos-wrapper">
          <ParagraphWithLogosComponent {...this.props} shadow={true} />
        </div>
      </StyledIntegrationsComponent>
    );
  }
}

IntegrationsComponent.defaultProps = {
  assets: INTEGRATIONS_ASSETS
};
